import { useEffect, useState } from "react";
import { useLanguage } from "../../context/Language/LanguageContext";
import MultiChoice from "../layout/MultiChoice";
import { getRotationLabels } from "../utils/Constants";

function AllFiltersPanel({
  allOptions,
  match,
  events,
  selectedTeam,
  handleFilterOptionChanged,
  appName,
}) {
  const { t } = useLanguage();
  const [, forceUpdate] = useState(0);
  const [filteredOptions, setFilteredOptions] = useState(allOptions);
  const validvbstats = [
    "Sets",
    "Rotations",
    "Attackers",
    "Stages",
    "Display",
    "Results",
  ];

  const doOptionChanged = (options, item) => {
    handleFilterOptionChanged(allOptions);
  };

  const selectedOptions = (filter) => {
    if (filter.items === undefined) {
      return;
    }
    const rotationLabels =
      filter.title === "Rotations" ? getRotationLabels() : null;
    var count = 0;
    var s = "";
    for (var n = 0; n < filter.items.length; n++) {
      if (filter.items[n].selected) {
        if (s.length > 0) s += ", ";
        if (rotationLabels) {
          const idx = parseInt(filter.items[n].name, 10) - 1;
          s +=
            idx >= 0 && idx < rotationLabels.length
              ? rotationLabels[idx]
              : filter.items[n].name.toUpperCase();
        } else {
          s += filter.items[n].name.toUpperCase();
        }
        count++;
      }
    }
    if (count == filter.items.length) {
      return t("ALL");
    } else if (count == 0) {
      return t("NONE");
    }
    return s;
  };

  const validFilter = (filter) => {
    const validvbstats = [
      "Sets",
      "Rotations",
      "Attackers",
      "Stages",
      "Display",
      "Results",
    ];
    if (appName === "VBStats") {
      return validvbstats.includes(filter.title);
    }
    return true;
  };

  useEffect(() => {
    if (appName === "VBStats") {
      var opts = [];
      for (var opt of allOptions) {
        if (validvbstats.includes(opt.title)) {
          opts.push(opt);
        }
      }
      setFilteredOptions(opts);
    } else {
      setFilteredOptions(allOptions);
    }
  }, [allOptions]);

  return (
    <>
      {filteredOptions.map((filter) => (
        <div
          key={filter.name}
          tabIndex={0}
          className="collapse collapse-arrow rounded-sm"
        >
          <input type="checkbox" className="peer" />
          <div className="collapse-title pt-2 bg-base-200 text-sm font-medium  peer-checked:bg-base-100 peer-checked:text-base-700">
            {t(filter.title).toUpperCase()}
            <p className="text-xs font-normal">{selectedOptions(filter)}</p>
          </div>
          <div className="collapse-content peer-checked:bg-base-100 ">
            <MultiChoice
              filter={filter}
              handleOptionChanged={(filter, item) =>
                doOptionChanged(filter, item)
              }
            ></MultiChoice>
          </div>
        </div>
      ))}
      <div className="collapse-title"></div>
      <div className="collapse-content"></div>
    </>
  );
}

export default AllFiltersPanel;
